export const PRODUCT = 'Product';
//# sourceMappingURL=product.js.map